<template lang="html">
  <v-card class="my-0 py-0 mx-0 d-flex flex-column" elevation="4" min-height="110" height="100%" :color="color">
    <v-card-subtitle class="pb-0 pt-5">
      {{ title }}
      <v-tooltip v-if="help" right>
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            small
            v-bind="attrs"
            v-on="on"
          >mdi-help-circle-outline</v-icon>
        </template>
        <span>{{ help }}</span>
      </v-tooltip>
    </v-card-subtitle>
    <v-card-title class="text-h5 font-weight-bold pt-0 pb-0">
      <slot></slot>
    </v-card-title>
    <v-card-text class="text-h6 py-0">
      {{ secondline }}
    </v-card-text>
    <v-spacer></v-spacer>
    <v-card-actions v-if="more">
      <v-spacer></v-spacer>
      <v-btn
        plain
        x-small
        :to="more"
      >
        more
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
    props: [
      'title', 'secondline', 'more', 'help', 'color'
    ]
  }
</script>

<style lang="css">
  .factor {
    font-size: 1.50em !important;
    font-weight: bold;
    color: green;
    text-shadow: 0px 0px 5px green;

  }
  .card-outter {
    position: relative;
    padding-bottom: 10px;
  }
  .card-actions {
    position: absolute;
    bottom: 30;
    right: 0;
  }
</style>
